export const navigation = [{
  name: 'Calendario',
  url: '/calendario',
  icon: 'icon-calendar',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
},
{
  name: 'Catalogos',
  url: '/catalogo',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'MINORISTA', 'MAYORISTAMINORISTA', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Presencia de Marca',
      url: '/catalogo/articulos-marca',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Clasificaciones',
      url: '/catalogo/clasificaciones',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Giros",
      url: '/catalogo/giros-clientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Ocupaciones",
      url: '/catalogo/ocupaciones',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Contactado En ",
      url: '/catalogo/contactado-en',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Productos",
      url: '/catalogo/productos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    }, {
      name: "Produtos Comparativa",
      url: '/catalogo/productos-comparativa',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Produtos Comparativa Minorista",
      url: '/catalogo/productos-comparativa-minorista',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos Clientes",
      url: '/catalogo/tipos-clientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos de Contacto",
      url: '/catalogo/tipos-contacto',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos de Obra",
      url: '/catalogo/tipos-obra',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos de Venta",
      url: '/catalogo/tipos-venta',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Asesores",
      url: '/catalogo/asesores',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Asesores Ciudades",
      url: '/catalogo/asesores-ciudades',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Potencial Contactos",
      url: '/catalogo/potenciales-contactos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Rutas",
      url: '/catalogo/rutas-minoristas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Tiendas HD",
      url: '/catalogo/tiendas-homedepot',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: "Articulos Promocionales",
      url: '/catalogo/articulos-promocionales',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Marcas Competencia HD",
      url: '/catalogo/marcas-competencia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: "SKUs Competencia HD",
      url: '/catalogo/skus-competencia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: "Tipos Tuberia",
      url: '/catalogo/tipos-tuberia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: "Compañías de Teléfono",
      url: '/catalogo/companias-telefono',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Tipos Flyer",
      url: '/catalogo/tipos-flyer',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Lineas",
      url: '/catalogo/lineas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }

  ]
},
{
  title: 'true',
  name: 'Operación'
},
{
  name: 'Mayoristas',
  url: '/visitas',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Alta Visita',
      url: '/visitas/mayoristas/add',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Listado Visita',
      url: '/visitas/mayoristas/list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen Ejecutivo",
      url: '/visitas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen de Participación",
      url: '/visitas/mayoristas/resumen-participacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen Plan VS Real",
      url: '/visitas/mayoristas/programacion-vs-real',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: "Mapa de rutas",
      url: '/visitas/mayoristas/mapa',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Personal Cliente",
      url: '/visitas/personal-cliente',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: "Productos Cliente",
      url: '/visitas/productos-cliente',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    }
  ]
},
{
  name: 'Reuniones Mayoristas',
  url: '/reuniones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Listado de minutas',
      url: '/reuniones/minutas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Acuerdos Minutas',
      url: '/reuniones/acuerdos-minutas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Resumen Acuerdos Minutas',
      url: '/reuniones/resumen-acuerdos-minutas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Estructura comercial',
      url: '/reuniones/estructura-comercial',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Pláticas Mayoristas',
      url: '/reuniones/platicas-mayoristas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Reuniones Vendedores Mayoristas',
      url: '/reuniones/reunion-vendedores-mayoristas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Reunion Vendedores Distribuidor',
      url: '/reuniones/reunion-vendedores-distribuidor-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Seguimiento Promociones',
      url: '/reuniones/seguimiento-promociones-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
  ]
},
{
  name: 'Home Depot',
  url: '/homedepot',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Programacion Home Depot',
      url: '/homedepot/programacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Visitas Homedepot',
      url: '/homedepot/homedepot-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Reporte Ejecutivo HD',
      url: '/homedepot/reporte-ejecutivo-homedepot',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Reporte Plan Vs Real',
      url: '/homedepot/reporte-plan-vs-real',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    }
  ]
},
{
  name: 'Distribuidores',
  url: '/reuniones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Reunion Vendedores Distribuidor',
      url: '/reuniones/reunion-vendedores-distribuidor-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Seguimiento Promociones',
      url: '/reuniones/seguimiento-promociones-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Area influencia',
      url: '/reuniones/area-influencia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
  ]
},
{
  name: 'Generales',
  url: '/generales',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO'],
  children: [
    {
      name: 'Proyectos logrados',
      url: '/generales/proyectos-logrados',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Potencial clientes',
      url: '/generales/potencial-clientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Potencial Segmento ABC',
      url: '/generales/potencial-contactos-2023',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Edades Segmentos',
      url: '/generales/reporte-edades-segmentos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'SEGUIMIENTO']
    }

  ]
},
{
  name: 'Promociones',
  url: '/promociones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO'],
  children: [
    {
      name: 'Alta de promocion',
      url: '/promociones/add',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Listado promociones',
      url: '/promociones/list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Resumen de Ventas",
      url: '/promociones/ventas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Control",
      url: '/promociones/control',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },

  ]
},
{
  name: 'Seguimiento Contactos',
  url: '/promociones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO', 'MINORISTA', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: "Prospectos Pendientes",
      url: '/promociones/contactos-pendientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Alta de Contacto",
      url: '/promociones/contacto/',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Contactos",
      url: '/promociones/contactos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Alta Fechas ABC',
      url: '/visitas/abc/add',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Fechas ABC',
      url: '/visitas/a/b/c',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Contactos por Semana",
      url: '/promociones/contactos-semana',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Contactos por Semana Contactados en",
      url: '/promociones/contactos-semana-contaactadoen',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Eventos',
      url: '/promociones/eventos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Resumen Visitas",
      url: '/promociones/visitas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Detalle Visitas",
      url: '/promociones/detalle-visitas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Resultados Formatos",
      url: '/promociones/resultados-formatos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Reporte Formatos",
      url: '/promociones/reporte-formatos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Reporte Eventos',
      url: '/reuniones/eventos-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Formatos Dinámicos',
      url: '/promociones/formularios-dinamicos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'SEGUIMIENTO']
    }
  ]
},
{
  name: 'Prospectos',
  url: '/prospectos',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR'],
  children: [
    {
      name: 'Alta de Prospecto',
      url: '/prospectos/prospecto',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Prospectos',
      url: '/prospectos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Recargas',
      url: '/prospectos/recargas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Reporte',
      url: '/prospectos/reporte',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }

  ]
},
{
  name: 'Minoristas',
  url: '/minoristas',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'MINORISTA', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Programación',
      url: '/visitas/minoristas/list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen Ejecutivo",
      url: '/minoristas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen Alcaldías",
      url: '/minoristas/alcaldias',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }
  ]
},
{
  name: 'Proyectos',
  url: '/segmentos',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Alta Manual',
      url: '/segmentos/alta-contacto-vist',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Obras',
      url: '/segmentos/contactos-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Obras en Proceso',
      url: '/segmentos/contactos-list-proceso',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    }, {
      name: 'Importar Inforte',
      url: '/segmentos/inforte',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Resumen de Visitas',
      url: '/segmentos/resumen-ejecutivo',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Proyectos Semana',
      url: '/segmentos/proyectos-semana',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Proyectos Convenios',
      url: '/segmentos/proyectos-convenios',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Proyectos Plan VS Real',
      url: '/segmentos/proyectos-real-plan',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Consumo Contactos Proyectos',
      url: '/segmentos/consumo-contactos-proyectos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Contactos Mayor Consumo',
      url: '/segmentos/contactos-mayor-consumo',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Gráfica Proyectos en Proceso',
      url: '/segmentos/reporte-proyectos-proceso-especificacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', "ASESOR"]
    }, {
      name: 'Proyectos en Proceso de Especificación',
      url: '/segmentos/reporte-proyectos-en-especificacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','ASESOR']
    }
  ]
},
{
  name: 'Redes Subterraneas',
  url: '/redes-subterraneas',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Proyectos',
      url: '/redes-subterraneas/proyectos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'En proceso',
      url: '/redes-subterraneas/proyectos/enproceso',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Resumen de Visitas',
      url: '/redes-subterraneas/resumen-ejecutivo',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    }
  ]
}, {
  name: 'Otros',
  url: '/otros',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Programacion Vacaciones',
      url: '/otros/programacion-vacaciones',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA']
    },
  ]
},
{
  name: 'Salir',
  url: '/logout',
  icon: 'icon-close',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
},
];



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/_nav.ts